import {
    BreakpointState,
    calcRem,
    ThemeConfig,
    TheNightlyTheme,
    TheNightlyThemeConfig,
} from '../../../__styling'

export type SectionContentTheme<T extends ThemeConfig> = {
    maxWidth: string
    gap: BreakpointState<T, string>
}

export const theNightlySectionContentTheme = (scheme: TheNightlyTheme) => {
    const theme: SectionContentTheme<TheNightlyThemeConfig> = {
        maxWidth: calcRem(scheme.siteMetrics.mainContentWidth),
        gap: {
            default: calcRem(48),
            lg: calcRem(scheme.margins.lg),
            sm: calcRem(24),
        },
    }
    return theme
}
